<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-if="!list && !rules"
        v-on="on"
        v-bind="attrs"
        style="cursor: pointer;"
        small
        color="info"
      >
        mdi-information-outline
      </v-icon>
      <v-btn
        v-else
        v-on="on"
        v-bind="attrs"
        :outlined="rules"
        color="primary"
        :class="
          {
            'mt-4' : marginTop,
            'px-9' : activeCampaigns
          }
        "
        small
        style="border-radius: 8px"
      >
        {{ $t("newCasino.freespins.detail") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat style="background-color: transparent">
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div class="backgroundFade mx-2">
          <div class="mb-12">
            <h2 style="color: #fff; padding-bottom: 1rem;">
              {{ title }}
            </h2>
            <div class="mb-2">
              {{ description }}
            </div>
            <div>
              <span>{{ $t("includedGames") }}:</span>
              <ul>
                <li v-for="(game) in campaignGames" :key="game.game_id">
                  <span>{{ game.game_name }}</span>
                </li>
              </ul>
            </div>
          </div>

          <h2 style="color: #fff; padding-bottom: 1rem;">
            {{ $t("help") }}
          </h2>
          <div class="pb-4 align-self-start">
            {{ $t("howItWorks") }}
          </div>
          <div class="mx-4 d-flex flex-column" style="gap: 12px">
            <span>
              {{ $t("newCasino.freespins.rules.first") }}
            </span>

            <span>
              {{ $t("newCasino.freespins.rules.second") }}
            </span>

            <span>
              {{ $t("newCasino.freespins.rules.third") }}
            </span>

            <span>
              {{ $t("newCasino.freespins.rules.fourth") }}
            </span>

            <span>
              {{ $t("newCasino.freespins.rules.fifth") }}
            </span>

            <span>
              {{ $t("newCasino.freespins.rules.sixth") }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    list: {
      type: Boolean,
    },
    rules: {
      type: Boolean,
    },
    marginTop: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    campaignGames: {
      type: Array,
    },
    activeCampaigns: {
      type: Boolean,
    }
  },

  data: () => ({
    dialog: false,
  }),
};
</script>
